const digest = '11553efbedf646c98dd9297f9c2934f53617d3df86969e1a0fa688ebfa95deda';
const css = `._modalBackground_171f7_1 {
  z-index: 1;
  height: 271px;
  width: 813px;
  opacity: 5%;
  position: absolute;
  top: 100px;
  right: 120px;
  pointer-events: none;
  transform: rotate(20deg);
}

@media (max-width: 768px) {
  ._modalBackground_171f7_1 {
    top: 114px;
    right: 40px
  }
}

@media (max-width: 425px) {
  ._modalBackground_171f7_1 {
    top: 133px;
    right: 54px;
  }
}

@media (max-width: 320px) {
  ._modalBackground_171f7_1 {
    top: 166px;
    right: 42px;
  }
}

@media (max-width: 425px) {
  ._padItem1_171f7_35 {
    padding-right: 0px;
    padding-left: 0px !important;
    padding-bottom: 20px;
  }
}


._padItem1_171f7_35 {
  padding-bottom: 20px;
}

._padEnd_171f7_47 {
  padding-right: 0px;
  padding-left: 0px;
  padding-bottom: 20px;
}

._newViewAllGridCenter_171f7_53 {
  margin-left:-15px;
}

._gridHorizontalTile_171f7_57 {
  padding-top: 10px;
  padding-bottom: 20px;
  background-color: #ecedee;
}

._flex-wrap_171f7_63 > div:last-child {
  border: none;
}

._tileBody_171f7_67 {
  display: flex;
  width: auto;
  padding-bottom: 24px;
  height: 100%;
}

._tileBody_171f7_67 button:focus{
  outline: 2px dashed #53565a !important;
  outline-offset: 2px;
}
._tileBody_171f7_67 a:focus{
  outline: 2px dashed #53565a !important;
  outline-offset: 2px;
}
._tileBody_171f7_67 button:hover{
  text-decoration: none;
  border-color: transparent !important;
}

._horizontalBody_171f7_87 {
  display: flex;
  width: auto;
}

@media (max-width: 768px) {
  ._horizontalBody_171f7_87 {
    display: flex;
    flex-direction: column;
  }
}

@media (max-width: 425px) {
 ._horizontalBody_171f7_87 {
    width: 90%;
    margin-bottom: 20px
  }
}

._category_171f7_106 {
  padding: 3px;
  margin: 5px;
  position: relative;
}

@media (max-width: 768px) {
  ._category_171f7_106 {
    padding-bottom: 10px;
  }
}

@media (max-width: 320px) {
  ._category_171f7_106 {
    top: 0 !important;
  }
}

._termsWidth_171f7_124 {
  width: 100%
}

._cardSpacing_171f7_128 {
  padding-bottom: 20px;
}


._category_171f7_106:nth-child(1) {
  list-style: none;
  padding-left: 5px;
}

._category_171f7_106 span {
  position: relative;
  right: 5px;
}

@media (min-width: 768px) {
  ._smallCent_171f7_144 {
    width: 50% !important;
  }
}

@media (max-width: 768px) {
  ._padEnd_171f7_47 {
    padding-right: 0px;
    padding-left: 0px;
    padding-bottom: 20px;
  }
}

@media (max-width: 425px) {
  ._padEnd_171f7_47 {
    padding-right: 0px;
    padding-left: 0px;
    padding-bottom: 20px;
  }
}

@media screen and (min-width: 321px) and (max-width: 375px) {
  ._gridWidth_171f7_166 {
    width: 350px;
  }

  ._padItem1_171f7_35 {
    padding-left: 0px;
    padding-bottom: 10px;
  }

  ._padEnd_171f7_47 {
    padding-right: 0px;
    padding-left: 0px;
    padding-bottom: 10px;
  }
}

@media screen and (min-width: 0) and (max-width: 320px) {
  ._gridWidth_171f7_166 {
    width: 300px;
  }

}

/*always one above max-width*/
@media (min-width: 1281px) {
  ._hiddenResponsiveUp_171f7_191 {
    display: none !important;
  }
}

@media (max-width: 1280px) {
  ._hiddenResponsiveDown_171f7_197 {
    display: none !important;
  }
}

._box_171f7_202 {
  height: 46px !important;
  width: 210px !important;
}

._box_171f7_202 a {
  color: white !important;
}

._container_171f7_211 {
  position: relative;
};


._container_171f7_211, img {
  display: 'block';
}

._container_171f7_211 ._ribbon_171f7_220 {
  position: absolute;
  top:0;
  right:0;
  height: 40px;
  width: 160px;
  border-radius: 0 4px 0 15.5px;
  background-color: #344B90;
  text-align: center;
}

._container_171f7_211 ._ribbonShort_171f7_231 {
  position: absolute;
  top:0;
  right:0;
  height: 40px;
  width: 125px;
  border-radius: 0 4px 0 15.5px;
  background-color: #344B90;
  text-align: center;
}


._container_171f7_211 ._ribbonEnroll_171f7_243 {
  position: absolute;
  top:0;
  right:0;
  height: 40px;
  width: 90px;
  border-radius: 0 4px 0 15.5px;
  background-color: #344B90;
  text-align: center;
}

._container_171f7_211 ._ribbonMidWidth_171f7_254 {
  position: absolute;
  top:0;
  right:0;
  height: 40px;
  width: 180px;
  border-radius: 0 4px 0 15.5px;
  background-color: #344B90;
  text-align: center;
}

._container_171f7_211 ._ribbonMidHeight_171f7_265 {
  position: absolute;
  top:0;
  right:0;
  height: 40px;
  width: 170px;
  border-radius: 0 4px 0 15.5px;
  background-color: #344B90;
  text-align: center;
}

._container_171f7_211 ._ribbonMaxWidth_171f7_276 {
  position: absolute;
  top:0;
  right:0;
  height: 41px;
  width: 170px;
  border-radius: 0 4px 0 15.5px;
  background-color: #344B90;
  text-align: center;
}

@media (max-width: 320px) {
  ._container_171f7_211 ._ribbonMaxWidth_171f7_276 {
    height: 38px;
    width: 236px;
  }
}

._container_171f7_211 ._ribbonMaxWidthHeight_171f7_294 {
  position: absolute;
  top:0;
  right:0;
  height: 55px;
  width: 190px;
  border-radius: 0 4px 0 15.5px;
  background-color: #344B90;
}

._label_171f7_304 {
  color: #FFFFFF;
  font-family: "Helvetica Neue",Helvetica,sans-serif;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 15px;
}

._span_171f7_313._icon_171f7_313._icon_171f7_313._sm_171f7_144._dls-icon-success_171f7_313::before {
  font-size: 16px !important;
}

._listViewLearnMoreBtn_171f7_317 {
  width: 50px;
  margin-left: auto;
}

@media (max-width: 768px) {
  ._listViewLearnMoreBtn_171f7_317 {
    height: 40px;
    margin-right: 0px;
    margin-top: 30px;
  }
}

@media (max-width: 425px) {
  ._listViewLearnMoreBtn_171f7_317 {
    margin-top: 50px;
    margin-left: 32px;
    padding-bottom: 30px;
    width: 280px;
  }
}

@media (max-width: 375px) {
  ._listViewLearnMoreBtn_171f7_317 {
    margin-top: 50px;
    margin-left: 27px;
    padding-bottom: 30px;
    width: 245px;
  }
}

@media (max-width: 319px) {
  ._listViewLearnMoreBtn_171f7_317 {
   width: auto;
  }
}

@media (min-width: 320px) and (max-width: 350px){
  ._listViewLearnMoreBtn_171f7_317 {
    width: 210px;
  }
}


@media screen and (min-width: 431px) and (max-width: 1023px) {
  ._gridWidth_171f7_166 {
    justify-content: center !important;
  }
  ._padItem1_171f7_35 {
    padding-right: 10px;
    padding-left: 0px;
    padding-bottom: 20px;
  }

  ._padEnd_171f7_47 {
    padding-right: 0;
    padding-left: 0px;
    padding-bottom: 20px;
  }
}

._categoryStyle_171f7_378 {
  display: inline-flex;
  padding-left: 0px;
  position: absolute;
  top: 45px;
  width: max-content;
}
`;
(function() {
  if ( global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'modalBackground': '_modalBackground_171f7_1', 'padItem1': '_padItem1_171f7_35', 'padEnd': '_padEnd_171f7_47', 'newViewAllGridCenter': '_newViewAllGridCenter_171f7_53', 'gridHorizontalTile': '_gridHorizontalTile_171f7_57', 'flex-wrap': '_flex-wrap_171f7_63', 'tileBody': '_tileBody_171f7_67', 'horizontalBody': '_horizontalBody_171f7_87', 'category': '_category_171f7_106', 'termsWidth': '_termsWidth_171f7_124', 'cardSpacing': '_cardSpacing_171f7_128', 'smallCent': '_smallCent_171f7_144', 'gridWidth': '_gridWidth_171f7_166', 'hiddenResponsiveUp': '_hiddenResponsiveUp_171f7_191', 'hiddenResponsiveDown': '_hiddenResponsiveDown_171f7_197', 'box': '_box_171f7_202', 'container': '_container_171f7_211', 'ribbon': '_ribbon_171f7_220', 'ribbonShort': '_ribbonShort_171f7_231', 'ribbonEnroll': '_ribbonEnroll_171f7_243', 'ribbonMidWidth': '_ribbonMidWidth_171f7_254', 'ribbonMidHeight': '_ribbonMidHeight_171f7_265', 'ribbonMaxWidth': '_ribbonMaxWidth_171f7_276', 'ribbonMaxWidthHeight': '_ribbonMaxWidthHeight_171f7_294', 'label': '_label_171f7_304', 'span': '_span_171f7_313', 'icon': '_icon_171f7_313', 'sm': '_sm_171f7_144', 'dls-icon-success': '_dls-icon-success_171f7_313', 'listViewLearnMoreBtn': '_listViewLearnMoreBtn_171f7_317', 'categoryStyle': '_categoryStyle_171f7_378' };
export const modalBackground = '_modalBackground_171f7_1';
export const padItem1 = '_padItem1_171f7_35';
export const padEnd = '_padEnd_171f7_47';
export const newViewAllGridCenter = '_newViewAllGridCenter_171f7_53';
export const gridHorizontalTile = '_gridHorizontalTile_171f7_57';
export const tileBody = '_tileBody_171f7_67';
export const horizontalBody = '_horizontalBody_171f7_87';
export const category = '_category_171f7_106';
export const termsWidth = '_termsWidth_171f7_124';
export const cardSpacing = '_cardSpacing_171f7_128';
export const smallCent = '_smallCent_171f7_144';
export const gridWidth = '_gridWidth_171f7_166';
export const hiddenResponsiveUp = '_hiddenResponsiveUp_171f7_191';
export const hiddenResponsiveDown = '_hiddenResponsiveDown_171f7_197';
export const box = '_box_171f7_202';
export const container = '_container_171f7_211';
export const ribbon = '_ribbon_171f7_220';
export const ribbonShort = '_ribbonShort_171f7_231';
export const ribbonEnroll = '_ribbonEnroll_171f7_243';
export const ribbonMidWidth = '_ribbonMidWidth_171f7_254';
export const ribbonMidHeight = '_ribbonMidHeight_171f7_265';
export const ribbonMaxWidth = '_ribbonMaxWidth_171f7_276';
export const ribbonMaxWidthHeight = '_ribbonMaxWidthHeight_171f7_294';
export const label = '_label_171f7_304';
export const span = '_span_171f7_313';
export const icon = '_icon_171f7_313';
export const sm = '_sm_171f7_144';
export const listViewLearnMoreBtn = '_listViewLearnMoreBtn_171f7_317';
export const categoryStyle = '_categoryStyle_171f7_378';
export { css, digest };